import * as zip from "@zip.js/zip.js/lib/zip-no-worker.js";
export { zip as default };